import { useBunja } from 'bunja/react';
import { useAtom, useAtomValue } from 'jotai';
import { ReactNode } from 'react';

import { T } from '@flipster/i18n';
import { Checkbox } from '@flipster/react/design-system/checkbox';
import { Explain } from '@flipster/react/design-utils/explain';
import { css } from '@flipster/styled-system/css';
import { hstack, stack } from '@flipster/styled-system/patterns';

// ROLLBACK(last-price): trigger price type 셀렉터 재활성화 시 복원 (useAtom import 포함).
// import { TriggerPriceTypeSelect } from '../../../../shared/trigger-price-type-select';
import { tpslModalBunja } from '../../../state';
import { tpslModalInputBunja } from '../../state';
import { tpslModalValidationBunja } from '../../validation';
import { TriggerPriceInput } from './trigger-condition-input';

export interface SetTriggerConditionSectionProps {
  title: ReactNode;
}
export const SetTriggerConditionSection = ({ title }: SetTriggerConditionSectionProps) => {
  const { triggerPriceStatusAtom } = useBunja(tpslModalValidationBunja);
  // ROLLBACK(last-price): 셀렉터 재활성화 시 triggerPriceTypeAtom 바인딩 복원.
  // const { isLimitTpslOrderAtom, triggerPriceTypeAtom } = useBunja(tpslModalInputBunja);
  // const [triggerPriceType, setTriggerPriceType] = useAtom(triggerPriceTypeAtom);
  const { isLimitTpslOrderAtom } = useBunja(tpslModalInputBunja);
  const { canLimitTpslAtom } = useBunja(tpslModalBunja);
  const triggerPriceStatus = useAtomValue(triggerPriceStatusAtom);
  const [isLimitTpslOrder, setIsLimitTpslOrder] = useAtom(isLimitTpslOrderAtom);
  const canLimitTpsl = useAtomValue(canLimitTpslAtom);

  const showMarketDisclaimer = !isLimitTpslOrder && triggerPriceStatus.status === 'valid';

  return (
    <section className={stack({ gap: 12 })}>
      <div className={stack({ gap: 8 })}>
        <div className={hstack({ justify: 'space-between', alignItems: 'center' })}>
          <p className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-5' })}>{title}</p>
          {canLimitTpsl && (
            <Checkbox checked={isLimitTpslOrder} onChange={(e) => setIsLimitTpslOrder(e.target.checked)}>
              <span className={css({ textStyle: 'Body/M/Regular', color: 'content.default.level-5' })}>
                <T id='Autogen_common.r251126.s_Limit_Order' />
              </span>
            </Checkbox>
          )}
          {/* ROLLBACK(last-price): Last/Mark 셀렉터 — MM 준비 완료 시 재활성화.
          <TriggerPriceTypeSelect value={triggerPriceType} onChange={setTriggerPriceType} placement='label-suffix' /> */}
        </div>
        <TriggerPriceInput />
      </div>
      {triggerPriceStatus.status === 'warning' ? (
        <Explain.Warning>{triggerPriceStatus.message}</Explain.Warning>
      ) : showMarketDisclaimer ? (
        <p className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-3' })}>
          <T id='Trade.r260420.Market_tp_sl_desc' />
        </p>
      ) : null}
    </section>
  );
};
